var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0758367 8.38278C0.123528 8.49805 0.1937 8.60621 0.286353 8.70055C0.288783 8.70303 0.291225 8.70549 0.29368 8.70794L7.29285 15.7071C7.68338 16.0976 8.31654 16.0976 8.70706 15.7071C9.09759 15.3166 9.09759 14.6834 8.70706 14.2929L3.41417 9L15 9C15.5522 9 16 8.55229 16 8C16 7.44772 15.5522 7 15 7L3.41417 7L8.70706 1.70711C9.09759 1.31658 9.09759 0.683417 8.70706 0.292894C8.31654 -0.0976312 7.68337 -0.0976312 7.29285 0.292894L0.292851 7.29289C0.0999365 7.48581 0.00231952 7.73793 0 7.99077M0.0758367 8.38278C0.0280543 8.26756 0.00119572 8.14146 9.58062e-09 8.00923L0.0758367 8.38278Z",
    fill: "#1776B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlue);
export default __webpack_public_path__ + "static/media/left-arrow-blue.d9eee5e0efb4198d5367ef6726251cbe.svg";
export { ForwardRef as ReactComponent };